import React, { FC } from 'react';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
    getToggleRowSelectedProps: () => {
        checked: boolean;
        style: object;
    };
    toggleRowSelected: () => {};
};

const ExpanderIcon: FC<boolean> = (isExpanded) => {
    return (
        <FontAwesomeIcon
            icon={isExpanded ? solid('caret-up') : solid('caret-down')}
            color={'#018ada'}
            style={{ width: '1.4em', height: '1.4em' }}
        />
    );
};

const SubComponentIcon: FC<Props> = (row) => {
    const { checked, style } = row.getToggleRowSelectedProps();
    return (
        <FontAwesomeIcon
            icon={checked ? solid('caret-down') : solid('caret-right')}
            color={'#018ada'}
            style={{ width: '1.4em', height: '1.4em', ...style }}
            onClick={() => {
                row.toggleRowSelected();
            }}
        />
    );
};

export default ExpanderIcon;

export { ExpanderIcon, SubComponentIcon };
